import { AddressDuringSickness } from "./address-during-sickness";

export class AbsenceInfo {
    absenceID: string
    txnID: string
    absenceUpdatedFlg: string
    typeOfLeave: string
    leavePin: string
    fromDate: string
    toDate: string
    addressDuringSickness: AddressDuringSickness
    constructor() {
        this.absenceID = ''
        this.txnID = ''
        this.absenceUpdatedFlg = ''
        this.typeOfLeave = ''
        this.leavePin = ''
        this.fromDate = ''
        this.toDate = ''
        this.addressDuringSickness = new AddressDuringSickness()
    }
}


// WEBPACK FOOTER //
// ./src/app/bean/absence-info.ts